import { PropsWithChildren } from 'react';

import Logo from '@asset/logo.icon.svg?react';
import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { RouteEnum } from '@enum/route.enum';
import { useMediaStep } from '@hook/style/use-media-step.hook';

import { Close, LayoutSider, LogoButton, LogoWrapper, Wrapper, WrapperClose } from './common-layout.style';

interface LeftLayoutProps extends PropsWithChildren {
  isMobile: boolean;
  isMobileMenuOpen: boolean;
  onClose: () => void;
}

export const LeftLayout = ({ children, isMobile, isMobileMenuOpen, onClose }: LeftLayoutProps) => {
  const width = useMediaStep<number | string>(366, 326, 241, '100%');
  const pr = useMediaStep(48, 48, 24, 24);

  return (
    <LayoutSider isMobile={isMobile} isMobileMenuOpen={isMobileMenuOpen} width={width}>
      <Wrapper pd={isMobile ? 32 : 0} pr={pr}>
        <LogoWrapper>
          {isMobile ? (
            <Logo />
          ) : (
            <LogoButton href={RouteEnum.Home.path} type={ButtonTypeEnum.Link}>
              <Logo />
            </LogoButton>
          )}
        </LogoWrapper>
        {isMobile && (
          <WrapperClose>
            <Button color='default' variant='link' onClick={onClose}>
              <Close />
            </Button>
          </WrapperClose>
        )}
        <div>{children}</div>
      </Wrapper>
    </LayoutSider>
  );
};
